import { Stack, Button, Typography, AppBar, FormControl, Select, MenuItem, Skeleton } from '@mui/material';
import { useTheme } from '@mui/system';
import React from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { useLogUserActionMutation } from '../../../api/physicianDashboardSlice';

function PeerComparisonTitle({ draft, peerList, selectedPeer, setSelectedPeer, isLoading }) {
    const theme = useTheme();
    const navigate = useNavigate();

    function navigateToCardReview() {
        navigate(`/physician/drafts/${draft.id}?current_tab=analysis`)
    }

    return (
        <AppBar position='sticky' sx={{ color: 'black', backgroundColor: theme.palette.background.white }}>
            <Stack pt={2} px={2} pb={1} spacing={0.5} sx={{ boxShadow: 2 }}>
                { draft &&
                    <Button 
                        variant='text'
                        startIcon={<ArrowBackIos />} 
                        onClick={navigateToCardReview}
                        style={{ color: `${theme.palette.hold.main}`, paddingTop: '0px', paddingBottom: '0px', alignSelf: 'start', display: 'flex' }}
                    >Back</Button>
                }
                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography variant='heavy'>Peer Comparison: </Typography>
                    {isLoading ? (
                        <Skeleton variant="rectangular" width={'50%'} height={28} sx={{ borderRadius: 1 }} />
                    ) : (
                        <PeerDropdown peerList={peerList} selectedPeer={selectedPeer} setSelectedPeer={setSelectedPeer} />
                    )}
                </Stack>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <Typography variant='heavy'>Card: </Typography>
                    {isLoading ? (
                        <Skeleton variant="text" width={'85%'} height={24} />
                    ) : (
                        <Typography variant='normal' fontSize='14px'>{draft?.card.name}</Typography>
                    )}
                </Stack>
            </Stack>
        </AppBar>        
    );
}

export default PeerComparisonTitle;


function PeerDropdown({ peerList, selectedPeer, setSelectedPeer }) {
    const theme = useTheme();
    const logUserAction = useLogUserActionMutation()[0];

    function handlePeerChange(peerId) {
        setSelectedPeer(peerId);
        logUserAction({ action: 'changed_peer_comparison_dropdown', data: { peerId } });
    }

    return (
        <FormControl variant="outlined" size="small" sx={{ width: '50%' }}>
            <Select
                value={selectedPeer}
                onChange={(e) => handlePeerChange(e.target.value)}
                p={0.5}
                sx={{
                    fontSize: '14px',
                    display: 'flex',
                    height: '28px',
                    backgroundColor: theme.palette.background.main,
                }}
            >
                { peerList.map((peer) => (
                    <MenuItem key={peer.physicianId} value={peer.physicianId}>Dr. {peer.last_name}, {peer.first_name}</MenuItem>
                ))}

            </Select>
        </FormControl>
    );
}